import {WizardAssetsRequestParams} from "./wizard-assets.request-params";

export class UserIconRequestParams extends WizardAssetsRequestParams {
  constructor(width: Number,height: Number, color: String) {
    super(width, height, color);

    this.resourceName = this.resourceName + '/User';
    this.c = null;
    this.version = 2;
    this.ratio = 3;
  }
}
